<div class="style-config-container">
  <div class="style-config-center">
    <div class="style-config-width">
      <div class="card style-config-card">
        <div class="card-header">
          <h5 class="style-config-title">Style Configuration</h5>
        </div>
        <div class="card-body">
          <app-style-state-toggle></app-style-state-toggle>
        </div>
      </div>
    </div>
  </div>
</div>
